import { createAction } from "@reduxjs/toolkit";
import {
  ANALYTICS_SAVE_FOR_LATER,
  ANALYTICS_PRODUCT_CLICK,
  ANALYTICS_PAGE_LOAD,
  ANALYTICS_LOYALTY_OPT_IN_CLICK,
  ANALYTICS_LOYALTY_OPT_IN_REJECT,
  ANALYTICS_VIEW_LIST_ITEM
} from "../constants";

export { default as applyAndRemovePendingEvents } from "./applyAndRemovePendingEvents";
export {
  analyticsAddPendingSmallViewSubmit,
  analyticsAddPendingSortRefinement,
  analyticsPendingClearRefinement,
  analyticsAddPendingSelectAll,
  analyticsAddPendingRefinementsToggled,
  analyticsPendingClearAllRefinements,
  analyticsAddPendingRefinementSelect,
  analyticsRemovePendingEvent
} from "./analyticsPending";

export {
  analyticsOpenFilterSmall,
  analyticsOpenRefinementType,
  analyticsCloseRefinementType,
  analyticsRefinementsCloseMobile,
  analyticsRefinementsSelect,
  analyticsRefinementsDeselect,
  analyticsSelectAll,
  analyticsRefinementsDone,
  analyticsRefinementsSort,
  analyticsRefinementsViewItems,
  analyticsClearRefinement,
  analyticsClearAllRefinements,
  analyticsRefinementsToggled,
  analyticsSmallViewSubmit
} from "./analyticsRefinements";

export {
  analyticsLoadMore,
  analyticsLoadPrevious
} from "./analyticsPagination";

export const analyticsSaveForLater = createAction(ANALYTICS_SAVE_FOR_LATER);
export const analyticsProductClick = createAction(ANALYTICS_PRODUCT_CLICK);
export const analyticsPageLoad = createAction(ANALYTICS_PAGE_LOAD);
export const analyticsViewListItem = createAction(ANALYTICS_VIEW_LIST_ITEM);
export const analyticsLoyaltyOptInClick = createAction(
  ANALYTICS_LOYALTY_OPT_IN_CLICK
);
export const analyticsLoyaltyOptInReject = createAction(
  ANALYTICS_LOYALTY_OPT_IN_REJECT
);
